import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromWorldMap from './reducers/world-map.reducer';
import {EffectsModule} from '@ngrx/effects';
import {WorldMapEffects} from './effects/world-map.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('worldMap', fromWorldMap.reducer),
    EffectsModule.forFeature([WorldMapEffects])
  ]
})
export class WorldMapModule { }
